import { createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, mergeProps as _mergeProps, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = { class: "input-wrapper d-flex" };
const _hoisted_2 = { class: "grow" };
const _hoisted_3 = { class: "input-wrapper d-flex delivery-fee-per-order-computed" };
const _hoisted_4 = { class: "input-wrapper d-flex delivery-fee-per-order-computed" };
const _hoisted_5 = { class: "input-wrapper d-flex" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_v_select = _resolveComponent("v-select");
    const _component_InputRow = _resolveComponent("InputRow");
    const _component_v_text_field = _resolveComponent("v-text-field");
    const _component_vue_datepicker_action_row = _resolveComponent("vue-datepicker-action-row");
    const _component_vue_datepicker = _resolveComponent("vue-datepicker");
    const _component_DialogHeader = _resolveComponent("DialogHeader");
    const _component_v_date_picker = _resolveComponent("v-date-picker");
    const _component_DialogFooter = _resolveComponent("DialogFooter");
    const _component_v_card = _resolveComponent("v-card");
    const _component_v_dialog = _resolveComponent("v-dialog");
    const _component_v_autocomplete = _resolveComponent("v-autocomplete");
    const _component_v_radio = _resolveComponent("v-radio");
    const _component_v_radio_group = _resolveComponent("v-radio-group");
    const _component_v_divider = _resolveComponent("v-divider");
    const _component_CardSection = _resolveComponent("CardSection");
    return (_openBlock(), _createBlock(_component_CardSection, {
        title: _ctx.$t(`${_ctx.storeDetailLc}management_fee`)
    }, {
        default: _withCtx(() => [
            _createCommentVNode(" 본사 계약 설정 "),
            _createVNode(_component_InputRow, {
                label: _ctx.$t(`${_ctx.lc}adjustment_type_setting`),
                "is-required": ""
            }, {
                default: _withCtx(() => [
                    _createVNode(_component_v_select, {
                        "item-title": "text",
                        "item-value": "value",
                        modelValue: _ctx.adjustmentTypeComputed,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.adjustmentTypeComputed) = $event)),
                        items: _ctx.adjustmentTypeOptionList,
                        rules: _ctx.formRules.adjustmentType.value,
                        variant: "outlined",
                        density: "compact",
                        "hide-details": "auto",
                        placeholder: _ctx.$t('common.select_field_placeholder', { field: _ctx.$t(`${_ctx.lc}adjustment_type_setting`) })
                    }, null, 8 /* PROPS */, ["modelValue", "items", "rules", "placeholder"])
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["label"]),
            _createCommentVNode(" 관리비 유형 "),
            _createVNode(_component_InputRow, {
                label: _ctx.$t(`${_ctx.lc}delivery_pay_flag`),
                "is-required": ""
            }, {
                default: _withCtx(() => [
                    _createVNode(_component_v_select, {
                        "item-title": "text",
                        "item-value": "value",
                        modelValue: _ctx.deliveryPayFlagComputed,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.deliveryPayFlagComputed) = $event)),
                        variant: "outlined",
                        density: "compact",
                        "hide-details": "auto",
                        "validate-on": "blur",
                        items: _ctx.deliveryPayFlagDetailOptionList
                    }, null, 8 /* PROPS */, ["modelValue", "items"])
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["label"]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dynamicList, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                    key: `store_detail_${index}`
                }, [
                    _createCommentVNode(" 기본료 "),
                    (item.key === 'deliveryFeeMonthly')
                        ? (_openBlock(), _createBlock(_component_InputRow, {
                            key: 0,
                            label: item.text[_ctx.deliveryPayFlagComputed],
                            "is-required": ""
                        }, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_text_field, {
                                    modelValue: _ctx.deliveryFeeMonthlyComputed,
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.deliveryFeeMonthlyComputed) = $event)),
                                    variant: "outlined",
                                    density: "compact",
                                    "hide-details": "auto",
                                    suffix: _ctx.$t('common.currency'),
                                    inputmode: "numeric",
                                    filled: _ctx.isMonthlyFixedAmount,
                                    disabled: _ctx.isMonthlyFixedAmount,
                                    oninput: "javascript: this.value = this.value.replace(/[^0-9]/g, '' );",
                                    maxlength: _ctx.DELIVERY_FEE_MONTHLY_MAX_LENGTH,
                                    onBlur: _cache[3] || (_cache[3] = ($event) => (_ctx.handleBlurDeliveryFeeMonthly(_ctx.deliveryFeeMonthlyComputed)))
                                }, null, 8 /* PROPS */, ["modelValue", "suffix", "filled", "disabled", "maxlength"])
                            ]),
                            _: 2 /* DYNAMIC */
                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["label"]))
                        : _createCommentVNode("v-if", true),
                    _createCommentVNode(" 청구 시작일 "),
                    (item.key === 'deliveryFeeMonthlyDay')
                        ? (_openBlock(), _createBlock(_component_InputRow, {
                            key: 1,
                            label: item.text[_ctx.deliveryPayFlagComputed],
                            "is-required": ""
                        }, {
                            default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_1, [
                                    (_ctx.isMonthlyCharge)
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                            _createVNode(_component_v_select, {
                                                "item-title": "text",
                                                "item-value": "value",
                                                modelValue: _ctx.isDeliveryFeeMonthlyDayUsed,
                                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.isDeliveryFeeMonthlyDayUsed) = $event)),
                                                variant: "outlined",
                                                density: "compact",
                                                "hide-details": "auto",
                                                items: _ctx.deliveryFeeMonthlyDayTypeOptionList,
                                                style: { "max-width": "125px" }
                                            }, null, 8 /* PROPS */, ["modelValue", "items"]),
                                            _createVNode(_component_vue_datepicker, {
                                                modelValue: _ctx.date,
                                                "onUpdate:modelValue": [
                                                    _cache[5] || (_cache[5] = ($event) => ((_ctx.date) = $event)),
                                                    _ctx.handleClickPickerSubmit
                                                ],
                                                "model-type": "yyyy-MM-dd",
                                                format: "yyyy-MM-dd",
                                                "min-date": _ctx.today,
                                                style: { "width": "100px" }
                                            }, {
                                                "action-row": _withCtx((props) => [
                                                    _createVNode(_component_vue_datepicker_action_row, _mergeProps({ ref_for: true }, props), null, 16 /* FULL_PROPS */)
                                                ]),
                                                "dp-input": _withCtx(() => [
                                                    _createVNode(_component_v_text_field, {
                                                        value: _ctx.deliveryFeeMonthlyDayComputed,
                                                        variant: "outlined",
                                                        density: "compact",
                                                        class: "ml-2",
                                                        readonly: "",
                                                        "hide-details": "",
                                                        "bg-color": "white",
                                                        "prepend-inner-icon": "mdi-calendar-month-outline"
                                                    }, null, 8 /* PROPS */, ["value"])
                                                ]),
                                                _: 1 /* STABLE */
                                            }, 8 /* PROPS */, ["modelValue", "min-date", "onUpdate:modelValue"]),
                                            _createVNode(_component_v_dialog, {
                                                modelValue: _ctx.isCalendarOpen,
                                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((_ctx.isCalendarOpen) = $event)),
                                                width: "360",
                                                "onClick:outside": _ctx.handleClickPickerCancel
                                            }, {
                                                activator: _withCtx(({ props }) => [
                                                    _createElementVNode("div", _hoisted_2, [
                                                        _createVNode(_component_v_text_field, _mergeProps({ ref_for: true }, props, {
                                                            modelValue: _ctx.deliveryFeeMonthlyDayComputed,
                                                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_ctx.deliveryFeeMonthlyDayComputed) = $event)),
                                                            class: "ml-2",
                                                            "prepend-inner-icon": "mdi-calendar-month",
                                                            readonly: "",
                                                            variant: "outlined",
                                                            density: "compact",
                                                            "hide-details": "auto",
                                                            disabled: !_ctx.isDeliveryFeeMonthlyDayUsed,
                                                            filled: !_ctx.isDeliveryFeeMonthlyDayUsed
                                                        }), null, 16 /* FULL_PROPS */, ["modelValue", "disabled", "filled"])
                                                    ])
                                                ]),
                                                default: _withCtx(() => [
                                                    _createVNode(_component_v_card, null, {
                                                        default: _withCtx(() => [
                                                            _createVNode(_component_DialogHeader, {
                                                                title: _ctx.$t(`${_ctx.storeDetailLc}select_delivery_fee_date`),
                                                                "on-cancel": _ctx.handleClickPickerCancel
                                                            }, null, 8 /* PROPS */, ["title", "on-cancel"]),
                                                            _createVNode(_component_v_date_picker, {
                                                                modelValue: _ctx.date,
                                                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((_ctx.date) = $event)),
                                                                class: "date-picker",
                                                                width: "360",
                                                                "title-date-format": _ctx.datePickerTitleDateFormat,
                                                                "day-format": _ctx.datePickerDayFormat,
                                                                "weekday-format": _ctx.datePickerWeekFormat,
                                                                scrollable: "",
                                                                min: _ctx.today
                                                            }, null, 8 /* PROPS */, ["modelValue", "title-date-format", "day-format", "weekday-format", "min"]),
                                                            _createVNode(_component_DialogFooter, {
                                                                cancel: "",
                                                                change: "",
                                                                small: "",
                                                                "on-cancel": _ctx.handleClickPickerCancel,
                                                                "on-change": _ctx.handleClickPickerSubmit
                                                            }, null, 8 /* PROPS */, ["on-cancel", "on-change"])
                                                        ]),
                                                        _: 1 /* STABLE */
                                                    })
                                                ]),
                                                _: 1 /* STABLE */
                                            }, 8 /* PROPS */, ["modelValue", "onClick:outside"])
                                        ], 64 /* STABLE_FRAGMENT */))
                                        : _createCommentVNode("v-if", true),
                                    _createCommentVNode(" 납입일 "),
                                    (['MONTHLY_FIXED_AMOUNT', 'PER_CASE'].includes(_ctx.deliveryPayFlagComputed))
                                        ? (_openBlock(), _createBlock(_component_v_autocomplete, {
                                            key: 1,
                                            "item-title": "text",
                                            "item-value": "value",
                                            modelValue: _ctx.deliveryFeeMonthlyDayComputed,
                                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((_ctx.deliveryFeeMonthlyDayComputed) = $event)),
                                            variant: "outlined",
                                            density: "compact",
                                            "hide-details": "auto",
                                            items: _ctx.filteredDeliveryFeeMonthlyDayOptionList,
                                            onBlur: _cache[10] || (_cache[10] = ($event) => (_ctx.handleBlurDeliveryFeeMonthlyDay(_ctx.deliveryFeeMonthlyDayComputed)))
                                        }, null, 8 /* PROPS */, ["modelValue", "items"]))
                                        : _createCommentVNode("v-if", true)
                                ])
                            ]),
                            _: 2 /* DYNAMIC */
                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["label"]))
                        : _createCommentVNode("v-if", true),
                    _createCommentVNode(" 월 충전 건수 "),
                    (item.key === 'endDeliveryCount')
                        ? (_openBlock(), _createBlock(_component_InputRow, {
                            key: 2,
                            "is-required": "",
                            label: item.text[_ctx.deliveryPayFlagComputed]
                        }, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_text_field, {
                                    modelValue: _ctx.endDeliveryCountComputed,
                                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => ((_ctx.endDeliveryCountComputed) = $event)),
                                    variant: "outlined",
                                    density: "compact",
                                    "hide-details": "auto",
                                    "validate-on": "blur",
                                    suffix: _ctx.$t('common.count'),
                                    inputmode: "numeric",
                                    oninput: "javascript: this.value = this.value.replace(/[^0-9]/g, '' );",
                                    maxlength: _ctx.END_DELIVERY_COUNT_MAX_LENGTH,
                                    onBlur: _cache[12] || (_cache[12] = ($event) => (_ctx.handleBlurEndDeliveryCount(_ctx.endDeliveryCountComputed)))
                                }, null, 8 /* PROPS */, ["modelValue", "suffix", "maxlength"])
                            ]),
                            _: 2 /* DYNAMIC */
                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["label"]))
                        : _createCommentVNode("v-if", true),
                    _createCommentVNode(" 월 충전 접수불가 "),
                    (item.key === 'isMonthlyChargeUnAccept')
                        ? (_openBlock(), _createBlock(_component_InputRow, {
                            key: 3,
                            label: item.text[_ctx.deliveryPayFlagComputed],
                            "is-required": ""
                        }, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_radio_group, {
                                    modelValue: _ctx.isMonthlyChargeUnAcceptComputed,
                                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event) => ((_ctx.isMonthlyChargeUnAcceptComputed) = $event)),
                                    "hide-details": "auto",
                                    inline: "",
                                    density: "compact"
                                }, {
                                    default: _withCtx(() => [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.isMonthlyChargeUnAcceptOptionList, (option, key) => {
                                            return (_openBlock(), _createBlock(_component_v_radio, {
                                                key: key,
                                                label: _ctx.$t(option.text),
                                                value: option.value
                                            }, null, 8 /* PROPS */, ["label", "value"]));
                                        }), 128 /* KEYED_FRAGMENT */))
                                    ]),
                                    _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["modelValue"])
                            ]),
                            _: 2 /* DYNAMIC */
                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["label"]))
                        : _createCommentVNode("v-if", true),
                    _createCommentVNode(" 건당 관리비 "),
                    (item.key === 'deliveryManagementFee')
                        ? (_openBlock(), _createBlock(_component_InputRow, {
                            key: 4,
                            label: item.text[_ctx.deliveryPayFlagComputed],
                            "is-required": ""
                        }, {
                            default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_3, [
                                    _createVNode(_component_v_text_field, {
                                        modelValue: _ctx.deliveryManagementFeePerOrderComputed,
                                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event) => ((_ctx.deliveryManagementFeePerOrderComputed) = $event)),
                                        variant: "outlined",
                                        density: "compact",
                                        "hide-details": "auto",
                                        suffix: _ctx.$t('common.currency'),
                                        oninput: "javascript: this.value = this.value.replace(/[^0-9]/g, '' );",
                                        maxlength: _ctx.DELIVERY_MANAGEMENT_FEE_PER_ORDER_MAX_LENGTH,
                                        onBlur: _cache[15] || (_cache[15] = ($event) => (_ctx.handleBlurDeliveryManagementFeePerOrder(_ctx.deliveryManagementFeePerOrderComputed)))
                                    }, null, 8 /* PROPS */, ["modelValue", "suffix", "maxlength"]),
                                    _createVNode(_component_v_text_field, {
                                        modelValue: _ctx.deliveryManagementFeeRatePerOrderComputed,
                                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event) => ((_ctx.deliveryManagementFeeRatePerOrderComputed) = $event)),
                                        variant: "outlined",
                                        density: "compact",
                                        "hide-details": "auto",
                                        suffix: _ctx.$t('unit.percent'),
                                        maxlength: 4,
                                        rules: _ctx.formRules.deliveryManagementFeeRatePerOrder.value,
                                        oninput: "javascript: this.value = this.value.replace(/(^\\.|\\s)/g, '');",
                                        onBlur: _cache[17] || (_cache[17] = ($event) => (_ctx.handleBlurDeliveryManagementFeeRatePerOrder(_ctx.deliveryManagementFeeRatePerOrderComputed)))
                                    }, null, 8 /* PROPS */, ["modelValue", "suffix", "rules"])
                                ])
                            ]),
                            _: 2 /* DYNAMIC */
                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["label"]))
                        : _createCommentVNode("v-if", true),
                    _createCommentVNode(" 관리비 부가세 "),
                    (item.key === 'vatRateMonthly')
                        ? (_openBlock(), _createBlock(_component_InputRow, {
                            key: 5,
                            label: item.text[_ctx.deliveryPayFlagComputed],
                            "is-required": ""
                        }, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_autocomplete, {
                                    "item-title": "text",
                                    "item-value": "value",
                                    modelValue: _ctx.vatRateMonthlyComputed,
                                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event) => ((_ctx.vatRateMonthlyComputed) = $event)),
                                    variant: "outlined",
                                    density: "compact",
                                    "hide-details": "auto",
                                    items: _ctx.vatRateOptionList,
                                    disabled: _ctx.isVatRateMonthlyDisabled,
                                    onBlur: _cache[19] || (_cache[19] = ($event) => (_ctx.handleBlurVatRateMonthly(_ctx.vatRateMonthlyComputed)))
                                }, null, 8 /* PROPS */, ["modelValue", "items", "disabled"])
                            ]),
                            _: 2 /* DYNAMIC */
                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["label"]))
                        : _createCommentVNode("v-if", true)
                ]));
            }), 128 /* KEYED_FRAGMENT */)),
            _createVNode(_component_v_divider, { class: "divider" }),
            _createCommentVNode(" 건당 상점 수수료"),
            _createVNode(_component_InputRow, {
                label: _ctx.$t(`${_ctx.lc}delivery_fee_per_order`),
                "is-required": ""
            }, {
                default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_4, [
                        _createVNode(_component_v_text_field, {
                            modelValue: _ctx.deliveryFeePerOrderComputed,
                            "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event) => ((_ctx.deliveryFeePerOrderComputed) = $event)),
                            variant: "outlined",
                            density: "compact",
                            "hide-details": "auto",
                            suffix: _ctx.$t('common.currency'),
                            oninput: "javascript: this.value = this.value.replace(/[^0-9]/g, '' );",
                            maxlength: _ctx.DELIVERY_FEE_PER_ORDER_MAX_LENGTH,
                            onBlur: _cache[21] || (_cache[21] = ($event) => (_ctx.handleBlurDeliveryFeePerOrder(_ctx.deliveryFeePerOrderComputed)))
                        }, null, 8 /* PROPS */, ["modelValue", "suffix", "maxlength"]),
                        _createVNode(_component_v_text_field, {
                            modelValue: _ctx.deliveryFeeRatePerOrderComputed,
                            "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event) => ((_ctx.deliveryFeeRatePerOrderComputed) = $event)),
                            variant: "outlined",
                            density: "compact",
                            "hide-details": "auto",
                            suffix: _ctx.$t('unit.percent'),
                            maxlength: 4,
                            rules: _ctx.formRules.deliveryFeeRatePerOrder.value,
                            oninput: "javascript: this.value = this.value.replace(/(^\\.|\\s)/g, '');",
                            onBlur: _cache[23] || (_cache[23] = ($event) => (_ctx.handleBlurDeliveryFeeRatePerOrder(_ctx.deliveryFeeRatePerOrderComputed)))
                        }, null, 8 /* PROPS */, ["modelValue", "suffix", "rules"])
                    ])
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["label"]),
            _createVNode(_component_v_divider, { class: "divider" }),
            _createCommentVNode(" 운행거리배율 "),
            _createVNode(_component_InputRow, {
                label: _ctx.$t(`${_ctx.lc}distance_product`),
                "is-required": ""
            }, {
                default: _withCtx(() => [
                    _createVNode(_component_v_autocomplete, {
                        "item-title": "text",
                        "item-value": "value",
                        modelValue: _ctx.distanceProductComputed,
                        "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event) => ((_ctx.distanceProductComputed) = $event)),
                        variant: "outlined",
                        density: "compact",
                        "hide-details": "auto",
                        items: _ctx.distanceProductOptionList,
                        onBlur: _cache[25] || (_cache[25] = ($event) => (_ctx.handleBlurDistanceProduct(_ctx.distanceProductComputed)))
                    }, null, 8 /* PROPS */, ["modelValue", "items"])
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["label"]),
            _createCommentVNode(" 대행료 결제방식 "),
            _createVNode(_component_InputRow, {
                label: _ctx.$t(`${_ctx.lc}delivery_pay_type`),
                "is-required": ""
            }, {
                default: _withCtx(() => [
                    _createVNode(_component_v_select, {
                        "item-title": "text",
                        "item-value": "value",
                        modelValue: _ctx.deliveryPayTypeComputed,
                        "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event) => ((_ctx.deliveryPayTypeComputed) = $event)),
                        variant: "outlined",
                        density: "compact",
                        "hide-details": "auto",
                        items: _ctx.deliveryPayTypeOptionList
                    }, null, 8 /* PROPS */, ["modelValue", "items"])
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["label"]),
            _createCommentVNode(" 대행료 부가세 "),
            _createVNode(_component_InputRow, {
                label: _ctx.$t(`${_ctx.lc}vat_rate`)
            }, {
                default: _withCtx(() => [
                    _createVNode(_component_v_autocomplete, {
                        "item-title": "text",
                        "item-value": "value",
                        modelValue: _ctx.vatRateComputed,
                        "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event) => ((_ctx.vatRateComputed) = $event)),
                        variant: "outlined",
                        density: "compact",
                        "hide-details": "auto",
                        items: _ctx.vatRateOptionList,
                        disabled: _ctx.isVatRateDisabled,
                        onBlur: _cache[28] || (_cache[28] = ($event) => (_ctx.handleBlurVatRate(_ctx.vatRateComputed)))
                    }, null, 8 /* PROPS */, ["modelValue", "items", "disabled"])
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["label"]),
            _createCommentVNode(" 선차감 "),
            _createVNode(_component_InputRow, {
                label: _ctx.$t(`${_ctx.lc}hub_delivery_prepayment_fee`),
                "is-required": ""
            }, {
                default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_5, [
                        _createVNode(_component_v_text_field, {
                            modelValue: _ctx.hubDeliveryPrePaymentFeeComputed,
                            "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event) => ((_ctx.hubDeliveryPrePaymentFeeComputed) = $event)),
                            variant: "outlined",
                            density: "compact",
                            "hide-details": "auto",
                            suffix: _ctx.$t('common.currency'),
                            inputmode: "numeric",
                            oninput: "javascript: this.value = this.value.replace(/[^0-9]/g, '' );",
                            maxlength: _ctx.HUB_DELIVERY_PREPAYMENT_FEE_MAX_LENGTH,
                            onBlur: _cache[30] || (_cache[30] = ($event) => (_ctx.handleBlurHubDeliveryPrePaymentFee(_ctx.hubDeliveryPrePaymentFeeComputed)))
                        }, null, 8 /* PROPS */, ["modelValue", "suffix", "maxlength"]),
                        _createVNode(_component_v_text_field, {
                            modelValue: _ctx.hubDeliveryPrePaymentFeeRateComputed,
                            "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event) => ((_ctx.hubDeliveryPrePaymentFeeRateComputed) = $event)),
                            variant: "outlined",
                            density: "compact",
                            "hide-details": "auto",
                            suffix: _ctx.$t('unit.percent'),
                            class: "ml-2",
                            inputmode: "numeric",
                            oninput: "javascript: this.value = this.value.replace(/[^0-9]/g, '' );",
                            maxlength: _ctx.HUB_DELIVERY_PREPAYMENT_FEE_RATE_MAX_LENGTH,
                            onBlur: _cache[32] || (_cache[32] = ($event) => (_ctx.handleBlurHubDeliveryPrePaymentFeeRate(_ctx.hubDeliveryPrePaymentFeeRateComputed)))
                        }, null, 8 /* PROPS */, ["modelValue", "suffix", "maxlength"])
                    ])
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["label"])
        ]),
        _: 1 /* STABLE */
    }, 8 /* PROPS */, ["title"]));
}
